const BASE_URL = 'https://assets.nixi1.dkv.es'

const getStaticImage = (imagePath) => `${BASE_URL}/dashboard_front/images${imagePath}`

const getInfoDoc = (filePath) => {
  return encodeURI(`${BASE_URL}/info${filePath}`)
}

const getTone = (tonePath) => `${BASE_URL}/dashboard_front/tones${tonePath}`

export {
  getStaticImage,
  getInfoDoc,
  getTone
}
